import { get } from 'lodash';
import { getCarZingCta } from 'site-modules/shared/components/inventory/utils/carzing';

export function getVdpCtas(vinData) {
  const carZingCta = getCarZingCta(vinData);
  return carZingCta ? [carZingCta] : get(vinData, 'computedDisplayInfo.ctas', []);
}
